function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Screens");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29,37 L32.6666667,37 C32.6666667,32.9535714 35.9535714,29.6666667 40,29.6666667 L40,26 C33.9238095,26 29,30.9369048 29,37 Z",
  id: "Path-Copy",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.3047433,58.9880917 L35.3047433,58.9761834 C35.3047433,58.4760345 35.2365172,57.987794 35.088694,57.5114617 C34.531514,55.653766 32.8144899,50.7713605 28.902859,46.0913962 C26.8560754,43.6501935 25.7644574,40.5540339 25.7644574,37.326883 C25.7417154,29.6579339 31.70013,23.9895802 38.488629,23.9895802 C45.5045484,23.9895802 51.2241715,29.9675499 51.2241715,37.326883 C51.2241715,40.5540339 50.1098116,43.6621018 48.074399,46.0913962 C44.1855101,50.7356356 42.468486,55.6180411 41.899935,57.4876451 C41.7521118,57.9639774 41.6838856,58.4760345 41.6838856,58.9761834 L41.6838856,58.9880917 L46.4597141,58.9880917 L46.4597141,58.9880917 C47.4262508,55.5108663 50.0188434,51.3667758 51.6676413,49.389997 C54.3625731,46.1628461 56,41.9473057 56,37.326883 C56,27.2048229 48.1653671,19 38.5,19 C28.322937,19 21,27.6454302 21,37.326883 C21,41.9473057 22.6374269,46.1628461 25.3323587,49.389997 C26.9925276,51.3667758 29.5851202,55.5108663 30.5402859,58.9880917 L30.5402859,59 L35.3047433,59 L35.3047433,58.9880917 Z",
  id: "Path-Copy-2",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30,61 L30,65.9558999 C30,66.3230036 30.0974212,66.6638856 30.280086,66.965435 L32.8861032,71.1871275 C33.2027221,71.6984505 33.7385387,72 34.2987106,72 L42.7012894,72 C43.273639,72 43.8094556,71.6984505 44.1138968,71.1871275 L46.719914,66.965435 C46.9025788,66.6638856 47,66.3098927 47,65.9558999 L47,61 L30,61 Z",
  id: "Path-Copy-3",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("line", {
  x1: 40,
  y1: 14,
  x2: 40,
  y2: 0,
  id: "Path-Copy-4",
  stroke: "#000000",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("line", {
  x1: 79,
  y1: 37,
  x2: 65,
  y2: 37,
  id: "Path-Copy-5",
  stroke: "#000000",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("line", {
  x1: 74,
  y1: 18,
  x2: 62,
  y2: 25,
  id: "Path-Copy-6",
  stroke: "#000000",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("line", {
  x1: 76,
  y1: 57,
  x2: 64,
  y2: 50,
  id: "Path-Copy-7",
  stroke: "#000000",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("line", {
  x1: 59,
  y1: 3,
  x2: 52,
  y2: 15,
  id: "Path-Copy-8",
  stroke: "#000000",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 37,
  x2: 14,
  y2: 37,
  id: "Path-Copy-9",
  stroke: "#000000",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("line", {
  x1: 5,
  y1: 18,
  x2: 17,
  y2: 25,
  id: "Path-Copy-10",
  stroke: "#000000",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("line", {
  x1: 3,
  y1: 57,
  x2: 15,
  y2: 50,
  id: "Path-Copy-11",
  stroke: "#000000",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("line", {
  x1: 20,
  y1: 3,
  x2: 27,
  y2: 15,
  id: "Path-Copy-12",
  stroke: "#000000",
  strokeWidth: 4
}));

var SvgAugmentingIdeation = function SvgAugmentingIdeation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "72px",
    viewBox: "0 0 79 72",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAugmentingIdeation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Augmenting-Ideation.c9a34607.svg";
export { ForwardRef as ReactComponent };